import { breakpoints, Card, Heading, Inline, Stack, Text, textVariants, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useSiteContext, useTranslation } from '@eti/providers';
import { constants } from '@eti/utils';
import { useOrderDetails } from '../../containers/OrderDetailsContext';

const cardStyles = css`
  border: 2px solid ${vars.colors.signal.information.light};
`;

const singleColumnStyles = css`
  flex: 1;
  word-break: break-all;
`;

const doubleColumnStyles = css`
  flex: 2;
  word-break: break-all;
`;

const AgentInfo = () => {
  const { t } = useTranslation();
  const { agencyAccount } = useSiteContext();
  const { customerDetails } = useOrderDetails();

  return (
    <Card className={cardStyles} data-testid="agent-info-box">
      <Stack spacing={8}>
        <Heading data-testid="agent-info-box-title" level={2}>
          {t('OrderDetails.AgentInfo.Box.Title')}
        </Heading>
        <Stack className={constants.MOUSE_FLOW_CLASS_NAMES} spacing={24}>
          <Inline collapseBelow={breakpoints._560} noWrap>
            <Stack className={singleColumnStyles} spacing={4}>
              <Text data-testid="agent-info-box-agency-name-label">
                {t('OrderDetails.AgentInfo.Box.AgencyName.Label')}
              </Text>
              <Text data-testid="agent-info-box-agency-name" variant={textVariants._16_BOLD}>
                {agencyAccount.name}
              </Text>
            </Stack>
            <Inline className={doubleColumnStyles} collapseBelow={breakpoints._560} noWrap>
              <Stack className={singleColumnStyles} spacing={4}>
                <Text data-testid="agent-info-box-agency-id-label">
                  {t('OrderDetails.AgentInfo.Box.AgencyID.Label')}
                </Text>
                <Text data-testid="agent-info-box-agency-id" variant={textVariants._16_BOLD}>
                  {agencyAccount.code}
                </Text>
              </Stack>
              <Stack className={singleColumnStyles} spacing={4}>
                <Text data-testid="agent-info-box-agent-name-label">
                  {t('OrderDetails.AgentInfo.Box.AgentName.Label')}
                </Text>
                <Text data-testid="agent-info-box-agent-name" variant={textVariants._16_BOLD}>
                  {customerDetails.name}
                </Text>
              </Stack>
            </Inline>
          </Inline>
          <Inline collapseBelow={breakpoints._560} noWrap>
            <Stack className={singleColumnStyles} spacing={4}>
              <Text data-testid="agent-info-box-phone-label">
                {t('OrderDetails.AgentInfo.Box.Phone.Label')}
              </Text>
              <Text data-testid="agent-info-box-phone" variant={textVariants._16_BOLD}>
                {customerDetails.phone}
              </Text>
            </Stack>
            <Stack className={doubleColumnStyles} spacing={4}>
              <Text data-testid="agent-info-box-email-label">
                {t('OrderDetails.AgentInfo.Box.AgentEmail.Label')}
              </Text>
              <Text data-testid="agent-info-box-email" variant={textVariants._16_BOLD}>
                {customerDetails.email}
              </Text>
            </Stack>
          </Inline>
        </Stack>
      </Stack>
    </Card>
  );
};

export default AgentInfo;
